import { render } from "./SocialMediaSharing.vue?vue&type=template&id=aaaba3b6"
import script from "./SocialMediaSharing.vue?vue&type=script&lang=js"
export * from "./SocialMediaSharing.vue?vue&type=script&lang=js"

import "./SocialMediaSharing.vue?vue&type=style&index=0&id=aaaba3b6&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__